import type {
  InventoryFormSchema,
  InventoryQuerySchema,
} from '@/_pages/settings/inventory-kits/shared/schemas/inventory';
import {
  booleanQueryToFormConverter,
  currencyInput,
  nullableNumericToNumericStringConverter,
} from '@/_schemas/generic';
import { strToStatus } from '@/_schemas/status-input';

import { vendorDetailsQueryToForm } from '../vendor-details';

export function inventoryQueryToForm({
  primary_sku,
  description,
  status,
  secondary_skus,
  images,
  inventory_category,

  last_order_cost,
  weight,
  minimum_stock,
  maximum_stock,
  minimum_order,
  units_per_order,
  current_stock,
  committed,
  track_stock_quantities,
  track_serial_numbers,
  discontinued,

  manufacturer,
  manufacturer_id,
  vendor_details,

  ...rest
}: InventoryQuerySchema): InventoryFormSchema {
  return {
    ...rest,
    status: strToStatus(status),

    description: description ?? '',
    manufacturer: manufacturer ?? '',
    manufacturer_id: manufacturer_id ?? '',
    primary_sku: primary_sku ?? '',
    secondary_skus: secondary_skus ?? [],
    images: images ?? [],
    inventory_category: inventory_category ?? [],

    last_order_cost: currencyInput.queryToFormConverter(last_order_cost),
    weight: nullableNumericToNumericStringConverter(weight),
    committed: nullableNumericToNumericStringConverter(committed),
    current_stock: nullableNumericToNumericStringConverter(current_stock),
    minimum_stock: nullableNumericToNumericStringConverter(minimum_stock),
    maximum_stock: nullableNumericToNumericStringConverter(maximum_stock),
    units_per_order: nullableNumericToNumericStringConverter(units_per_order),
    minimum_order: nullableNumericToNumericStringConverter(minimum_order),

    track_stock_quantities: booleanQueryToFormConverter(track_stock_quantities),
    track_serial_numbers: booleanQueryToFormConverter(track_serial_numbers),
    discontinued: booleanQueryToFormConverter(discontinued),
    vendor_details: vendorDetailsQueryToForm(vendor_details),
  };
}
